import { SagaIterator } from 'redux-saga'
import { put, takeLatest, select, all } from 'redux-saga/effects'

import * as muteAudioActions from '../actions/muteAudio'
import { accountSelectors } from '../../account'

function* onRemoteAudioMuted({
  payload: [{ value: userId }],
}: ReturnType<typeof muteAudioActions.onRemoteAudioMuted>): SagaIterator {
  const currentUserId: ReturnType<typeof accountSelectors.getCurrentUserId> = yield select(
    accountSelectors.getCurrentUserId
  )
  if (currentUserId === parseInt(userId, 10)) {
    yield put(muteAudioActions.muteAudio())
  }
}

function* onAudioMuted() {
  yield put(muteAudioActions.onMuteAudioProgressStateUpdate(false))
}

function* muteAudio() {
  yield put(muteAudioActions.onMuteAudioProgressStateUpdate(true))
}

function* muteAudioSaga() {
  yield all([
    takeLatest(muteAudioActions.onRemoteAudioMuted, onRemoteAudioMuted),
    takeLatest(muteAudioActions.onAudioMuted, onAudioMuted),
    takeLatest(muteAudioActions.muteAudio, muteAudio),
  ])
}

export default muteAudioSaga
